import { Box, MenuItem, Typography } from '@mui/material';
import {
  CustomCheckbox,
  CustomTextField,
  CustomSelect,
  HorizontalForm,
  VerticalForm,
  DialogTitle,
  CustomTextArea,
} from '../../../common';
import { LEGAL_ENTITY_FLAGS, LEGAL_ENTITY_FLAGS_TITLE } from '../constants/legalEntitiesConstants';

const AdditionalDataSection = ({
  selectedLegalEntity,
  onInputChange,
  onSelectChange,
  onCheckboxChange,
  isMobile,
}) => {
  const flags = (
    <Box sx={{ px: isMobile ? 0 : 1, mt: 2 }}>
      <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700, mb: 0.5 }}>
        {LEGAL_ENTITY_FLAGS_TITLE}
      </Typography>
      <Box
        sx={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', columnGap: 2 }}
      >
        {LEGAL_ENTITY_FLAGS.map((flag) => (
          <CustomCheckbox
            key={flag.name}
            name={flag.name}
            label={flag.label}
            checked={Boolean(selectedLegalEntity[flag.name])}
            onChange={onCheckboxChange}
            size="small"
            labelSx={{ fontSize: '14px' }}
          />
        ))}
      </Box>
    </Box>
  );

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos adicionales
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomSelect
            label="¿Entidad intermedia?"
            name="is_intermediate_entity"
            value={selectedLegalEntity.is_intermediate_entity || '0'}
            onChange={onSelectChange}
            size="medium"
          >
            <MenuItem value="0">No</MenuItem>
            <MenuItem value="1">Sí</MenuItem>
          </CustomSelect>
          <CustomTextField
            label="Persona de contacto"
            name="contact_information"
            value={selectedLegalEntity.contact_information || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Cuota social"
            name="membership_fee"
            type="number"
            value={selectedLegalEntity.membership_fee || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextArea
            label="Observaciones"
            name="observations"
            value={selectedLegalEntity.observations || ''}
            onChange={onInputChange}
            rows={4}
            placeholder="Ingrese observaciones aquí"
          />
        </VerticalForm>
      ) : (
        <HorizontalForm withBorder={false} sx={{ p: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomSelect
              label="¿Entidad intermedia?"
              name="is_intermediate_entity"
              value={selectedLegalEntity.is_intermediate_entity || '0'}
              onChange={onSelectChange}
              size="medium"
            >
              <MenuItem value="0">No</MenuItem>
              <MenuItem value="1">Sí</MenuItem>
            </CustomSelect>
            <CustomTextField
              label="Persona de contacto"
              name="contact_information"
              value={selectedLegalEntity.contact_information || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomTextField
              label="Cuota social"
              name="membership_fee"
              type="number"
              value={selectedLegalEntity.membership_fee || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextArea
              label="Observaciones"
              name="observations"
              value={selectedLegalEntity.observations || ''}
              onChange={onInputChange}
              rows={4}
              placeholder="Ingrese observaciones aquí"
            />
          </Box>
        </HorizontalForm>
      )}
      {flags}
    </Box>
  );
};

export default AdditionalDataSection;
